import { Icon, createIcon } from "@chakra-ui/react";

export const CottonIcon = (props) => (
  <Icon
    {...props}
    width="38"
    height="35"
    viewBox="0 0 44 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.3311 21.9565C43.3701 23.4849 43.1027 25.0057 42.5447 26.4291C41.9866 27.8526 41.1492 29.15 40.0819 30.2448C39.0145 31.3396 37.7387 32.2097 36.3298 32.8037C34.9208 33.3978 33.4071 33.7039 31.878 33.7039C30.3489 33.7039 28.8352 33.3978 27.4263 32.8037C26.0173 32.2097 24.7415 31.3396 23.6742 30.2448C22.6068 29.15 21.7694 27.8526 21.2114 26.4291C20.6533 25.0057 20.3859 23.4849 20.4249 21.9565C20.3859 20.4281 20.6533 18.9073 21.2114 17.4838C21.7694 16.0604 22.6068 14.763 23.6742 13.6682C24.7415 12.5734 26.0173 11.7033 27.4263 11.1092C28.8352 10.5151 30.3489 10.2091 31.878 10.2091C33.4071 10.2091 34.9208 10.5151 36.3298 11.1092C37.7387 11.7033 39.0145 12.5734 40.0819 13.6682C41.1492 14.763 41.9866 16.0604 42.5447 17.4838C43.1027 18.9073 43.3701 20.4281 43.3311 21.9565Z"
      fill="#EDEDED"
    />
    <path
      d="M33.1191 11.7235C33.1368 13.2455 32.8545 14.7561 32.2883 16.1689C31.7221 17.5818 30.8832 18.8693 29.8193 19.958C28.7554 21.0467 27.4875 21.9151 26.0879 22.5138C24.6883 23.1124 23.1845 23.4296 21.6623 23.4471C18.5894 23.4098 15.6571 22.1538 13.5101 19.9554C11.3631 17.757 10.1771 14.796 10.2129 11.7235C10.1771 8.65106 11.3631 5.69012 13.5101 3.4917C15.6571 1.29328 18.5894 0.0373356 21.6623 0C23.1845 0.0175157 24.6883 0.33466 26.0879 0.933322C27.4875 1.53198 28.7554 2.40044 29.8193 3.48909C30.8832 4.57774 31.7221 5.86527 32.2883 7.27815C32.8545 8.69102 33.1368 10.2016 33.1191 11.7235Z"
      fill="#EDEDED"
    />
    <path
      d="M13.8803 15.3904C13.8485 12.5636 14.9396 9.83967 16.9142 7.8164C18.8889 5.79312 21.5857 4.63582 24.4128 4.59849C26.0329 4.60427 27.6294 4.98712 29.0758 5.71672C30.5223 6.44631 31.779 7.50262 32.7464 8.80198C32.1436 6.30986 30.7257 4.09041 28.7177 2.49581C26.7096 0.901212 24.2265 0.0228115 21.6623 0C18.5894 0.0373356 15.6571 1.29328 13.5101 3.4917C11.3631 5.69012 10.1771 8.65106 10.2129 11.7235C10.2041 13.7898 10.7396 15.8219 11.7654 17.6156C12.7913 19.4093 14.2714 20.9013 16.0569 21.9416C14.6389 20.0522 13.8749 17.7526 13.8803 15.3904Z"
      fill="#F6F6F6"
    />
    <path
      d="M22.9071 21.8C22.9268 23.3232 22.646 24.8354 22.0807 26.25C21.5154 27.6646 20.6767 28.9538 19.6126 30.0441C18.5485 31.1343 17.2799 32.0041 15.8794 32.6037C14.4788 33.2033 12.9737 33.5209 11.4503 33.5384C9.92748 33.52 8.42323 33.2016 7.02352 32.6016C5.62381 32.0016 4.35609 31.1316 3.2928 30.0415C2.2295 28.9513 1.39149 27.6624 0.82666 26.2483C0.261825 24.8341 -0.0187603 23.3226 0.00093932 21.8C-0.0348606 18.7275 1.15111 15.7666 3.29812 13.5681C5.44513 11.3697 8.37741 10.1138 11.4503 10.0764C12.9725 10.094 14.4763 10.4111 15.8759 11.0098C17.2755 11.6084 18.5434 12.4769 19.6073 13.5655C20.6712 14.6542 21.5102 15.9417 22.0764 17.3546C22.6425 18.7675 22.9248 20.278 22.9071 21.8Z"
      fill="#EDEDED"
    />
    <path
      d="M3.66831 25.4669C3.6345 22.6395 4.72499 19.9144 6.70005 17.8907C8.67512 15.867 11.3731 14.7103 14.2008 14.6749C15.8209 14.6807 17.4174 15.0636 18.8638 15.7932C20.3103 16.5228 21.567 17.5791 22.5344 18.8784C21.9316 16.3863 20.5137 14.1669 18.5057 12.5723C16.4976 10.9777 14.0145 10.0993 11.4503 10.0764C8.37741 10.1138 5.44513 11.3697 3.29812 13.5681C1.15112 15.7666 -0.0348597 18.7275 0.000940154 21.8C-0.0123572 23.8711 0.520915 25.9091 1.54695 27.7084C2.57299 29.5076 4.05549 31.0044 5.84488 32.0478C4.4208 30.1503 3.65643 27.8392 3.66831 25.4669Z"
      fill="#F6F6F6"
    />
    <path
      d="M24.0923 25.6234C24.0585 22.796 25.149 20.0709 27.124 18.0472C29.0991 16.0235 31.7971 14.8668 34.6248 14.8314C36.2449 14.8372 37.8414 15.2201 39.2878 15.9497C40.7343 16.6792 41.991 17.7356 42.9584 19.0349C42.3129 16.2811 40.6682 13.8648 38.3428 12.2542C36.0174 10.6436 33.1769 9.95325 30.3716 10.317C27.5662 10.6807 24.9958 12.0726 23.1581 14.2229C21.3205 16.3733 20.3465 19.1291 20.4249 21.9565C20.4169 24.0226 20.9526 26.0544 21.9784 27.848C23.0042 29.6415 24.4839 31.1336 26.2689 32.1745C24.8543 30.2834 24.0907 27.9849 24.0923 25.6234Z"
      fill="#F6F6F6"
    />
    <path
      d="M21.6623 33.1434C16.0122 27.7996 8.85631 27.9263 3.3627 31.7497C7.88729 35.1856 14.909 39.0611 21.6623 40.6262C28.4082 39.0611 35.4448 35.1856 39.9693 31.7497C34.4757 27.9338 27.3199 27.7996 21.6623 33.1434Z"
      fill="#86AD1C"
    />
    <path
      d="M21.6623 21.9565C13.7834 26.1227 14.4543 33.2627 17.1899 36.5718C18.5601 38.0506 20.0566 39.4072 21.6623 40.6262C23.2684 39.4077 24.7649 38.051 26.1347 36.5718C28.8778 33.2627 29.5486 26.1227 21.6623 21.9565Z"
      fill="#95C11F"
    />
    <path
      opacity="0.1"
      d="M43.3311 21.9565C43.3313 21.2821 43.2742 20.6089 43.1604 19.9442C37.7182 29.3797 28.0653 35.6625 17.0706 35.6625C12.9826 35.6675 8.94112 34.7958 5.21875 33.1062C9.69116 36.1544 15.7736 39.2623 21.6176 40.6262C28.3635 39.0611 35.4 35.1855 39.9246 31.7497C39.6116 31.5336 39.2836 31.3249 38.9556 31.1311C40.3223 30.0242 41.4244 28.6261 42.1814 27.0387C42.9385 25.4514 43.3312 23.715 43.3311 21.9565Z"
      fill="#1D1D1B"
    />
  </Icon>
);

export const ForwardIcon = (props) => (
  <Icon
    {...props}
    width="13"
    height="22"
    viewBox="0 0 13 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.9265 0.883503L12.5606 10.2218C12.675 10.333 12.7558 10.4534 12.8031 10.5831C12.8511 10.7128 12.8751 10.8518 12.8751 11C12.8751 11.1482 12.8511 11.2872 12.8031 11.4169C12.7558 11.5466 12.675 11.667 12.5606 11.7782L2.9265 21.1443C2.65968 21.4037 2.32616 21.5334 1.92593 21.5334C1.52569 21.5334 1.18264 21.3944 0.896759 21.1165C0.61088 20.8386 0.46794 20.5143 0.46794 20.1437C0.46794 19.7732 0.61088 19.4489 0.896759 19.171L9.30162 11L0.896759 2.82898C0.629938 2.56959 0.496528 2.25016 0.496528 1.8707C0.496528 1.49049 0.639467 1.16143 0.925347 0.883503C1.21123 0.605577 1.54475 0.466616 1.92593 0.466616C2.3071 0.466616 2.64063 0.605577 2.9265 0.883503Z"
      fill="#4848AA"
    />
  </Icon>
);

export const BackwardIcon = (props) => (
  <Icon
    {...props}
    width="13"
    height="22"
    viewBox="0 0 13 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0735 21.1165L0.439353 11.7782C0.325001 11.667 0.244192 11.5466 0.196927 11.4169C0.148899 11.2872 0.124886 11.1482 0.124886 11C0.124886 10.8518 0.148899 10.7128 0.196927 10.5831C0.244192 10.4534 0.325001 10.333 0.439353 10.2218L10.0735 0.855709C10.3403 0.596312 10.6738 0.466614 11.0741 0.466614C11.4743 0.466614 11.8174 0.605577 12.1032 0.883502C12.3891 1.16143 12.5321 1.48567 12.5321 1.85624C12.5321 2.22681 12.3891 2.55106 12.1032 2.82898L3.69838 11L12.1032 19.171C12.3701 19.4304 12.5035 19.7498 12.5035 20.1293C12.5035 20.5095 12.3605 20.8386 12.0747 21.1165C11.7888 21.3944 11.4552 21.5334 11.0741 21.5334C10.6929 21.5334 10.3594 21.3944 10.0735 21.1165Z"
      fill="#4848AA"
    />
  </Icon>
);

export const DownIcon = (props) => (
  <Icon
    {...props}
    width="10"
    height="5"
    viewBox="-3 -3 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.06528 0.567858C1.53187 0.159591 2.22846 0.159215 2.69549 0.566978L8 5.19831L13.3045 0.566977C13.7715 0.159214 14.4681 0.159591 14.9347 0.567859C15.4987 1.06132 15.4987 1.93864 14.9347 2.4321L8 8.49998L1.06528 2.4321C0.501324 1.93864 0.501326 1.06132 1.06528 0.567858Z"
      fill="#1C1C1C"
    />
  </Icon>
);

export const Loader = (props) => (
  <Icon
    {...props}
    style={{
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto",
    }}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke={props.color ? props.color : "#fff"}
      stroke-width="10"
      r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1s"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
      ></animateTransform>
    </circle>
  </Icon>
);

